import React from "react";

import { Option } from "./SelectWithIcons";

import { withTheme } from "styled-components/macro";

const colorByTestKey = (testKey, theme) => {
  return (
    {
      "terman-armstrong": ["#d86062", "#f6dadb"],
      "inteligenciaEmocional-armstrong": ["#d86062", "#f6dadb"],
      "estiloTrabajo-armstrong": ["#d86062", "#f6dadb"],
      "lateralidadCerebral-armstrong": ["#d86062", "#f6dadb"],
      "cleaver-armstrong": ["#d86062", "#f6dadb"],
      "comunicacionLaboral-armstrong": ["#d86062", "#f6dadb"],
      "capacidadEducativa-armstrong": ["#d86062", "#f6dadb"],
      "adaptabilidadSocial-armstrong": ["#d86062", "#f6dadb"],
      "psicoAtento-armstrong": ["#d86062", "#f6dadb"],
      "psicometrica-armstrong": ["#d86062", "#f6dadb"],
      "escuchaActiva-armstrong": ["#d86062", "#f6dadb"],
      "computacion-armstrong": ["#d86062", "#f6dadb"],
      "lenguajeSeguros-armstrong": ["#d86062", "#f6dadb"],
      "lenguajeIngles-armstrong": ["#d86062", "#f6dadb"],
      "lenguajeIngles2-armstrong": ["#d86062", "#f6dadb"],
      "asesorTelefonico-armstrong": ["#d86062", "#f6dadb"],
      "epe-armstrong": ["#d86062", "#f6dadb"],
      "ort1-armstrong": ["#d86062", "#f6dadb"],
      "pceng1-armstrong": ["#d86062", "#f6dadb"],
      "pcesp1-armstrong": ["#d86062", "#f6dadb"],

      "terman-khor": ["#87b351", "#e9f1df"],
      "inteligenciaEmocional-khor": ["#87b351", "#e9f1df"],
      "rolesYNecesidades-khor": ["#87b351", "#e9f1df"],
      "estiloSocial-khor": ["#87b351", "#e9f1df"],
      "estiloGerencial-khor": ["#87b351", "#e9f1df"],
      "apv-khor": ["#87b351", "#e9f1df"],
      "comprension-khor": ["#87b351", "#e9f1df"],
      "excel-khor": ["#87b351", "#e9f1df"],
      "word-khor": ["#87b351", "#e9f1df"],
      "confiabilidadEspañol-khor": ["#87b351", "#e9f1df"],
      "confiabilidadIngles-khor": ["#87b351", "#e9f1df"],

      "integrity-midot": ["#ecb416", "#fbf0d0"],
      "integrityAndWork-midot": ["#ecb416", "#fbf0d0"],

      "typing-worcket": ["#ecb416", "#fbf0d0"],
      "typingEnglish-worcket": ["#ecb416", "#fbf0d0"],
      "successProbability-worcket": [theme["@light"], theme["@primary"]],
      "identityVerification-worcket": [theme["@light"], "#7DCB13"],
      "reliability-worcket": ["#87b351", "#e9f1df"],
      "reliabilityEnglish-worcket": ["#87b351", "#e9f1df"],
      "equifax-worcket": [theme["@light"], "#AA2139"],
      "grammar-worcket": ["#505053", "#eaeaeb"],

      brainDominance: ["#d86062", "#f6dadb"],
      socialStyle: ["#87b351", "#e9f1df"],
      motivationalProfile: ["#02b4f4", "#ccedf6"],
      salesPersonality: ["#823161", "#f8edf3"],
      managerialStyle: ["#2e75b8", "#ebf3fa"],
      basicPersonality: ["#f18f1e", "#fdeedd"],
      personality16: ["#e71454", "#fbd0dd"],
      ivo: ["#77a940", "#e6f1da"],
      speed: ["#ecb416", "#fbf0d0"]
    }[testKey] || ["#505053", "#eaeaeb"]
  );
};

const iconByTestKey = testKey => {
  return (
    {
      "terman-armstrong": "form",
      "inteligenciaEmocional-armstrong": "smile",
      "estiloTrabajo-armstrong": "project",
      "lateralidadCerebral-armstrong": "user",
      "cleaver-armstrong": "form",
      "comunicacionLaboral-armstrong": "team",
      "capacidadEducativa-armstrong": "solution",
      "adaptabilidadSocial-armstrong": "team",
      "psicoAtento-armstrong": "user",
      "psicometrica-armstrong": "user",
      "escuchaActiva-armstrong": "sound",
      "computacion-armstrong": "laptop",
      "lenguajeSeguros-armstrong": "user",
      "lenguajeIngles-armstrong": "user",
      "lenguajeIngles2-armstrong": "user",
      "asesorTelefonico-armstrong": "user",
      "epe-armstrong": "user",
      "ort1-armstrong": "edit",
      "pceng1-armstrong": "laptop",
      "pcesp1-armstrong": "laptop",

      "terman-khor": "form",
      "inteligenciaEmocional-khor": "smile",
      "rolesYNecesidades-khor": "profile",
      "estiloSocial-khor": "team",
      "estiloGerencial-khor": "project",
      "apv-khor": "dollar",
      "comprension-khor": "user",
      "excel-khor": "table",
      "word-khor": "read",
      "confiabilidadEspañol-khor": "user",
      "confiabilidadIngles-khor": "user",

      "integrity-midot": "user",
      "integrityAndWork-midot": "user",

      "typing-worcket": "thunderbolt",
      "typingEnglish-worcket": "thunderbolt",
      "successProbability-worcket": "bulb",
      "identityVerification-worcket": "idcard",
      "reliability-worcket": "user",
      "reliabilityEnglish-worcket": "user",
      "equifax-worcket": "idcard",
      "grammar-worcket": "edit",

      brainDominance: "user",
      socialStyle: "team",
      motivationalProfile: "smile",
      salesPersonality: "dollar",
      managerialStyle: "project",
      basicPersonality: "user",
      personality16: "solution",
      ivo: "profile",
      speed: "thunderbolt"
    }[testKey] || "build"
  );
};

const TestOption = ({ t, testKey, source, idTest, name, cost, theme }) => {
  const [iconColor, iconBackgroundColor] = colorByTestKey(testKey, theme);

  return (
    <Option
      title={t([
        `opportunity:process.stepTypes.test-${source}.${idTest}.title`,
        name
      ])}
      subtitle={
        cost &&
        `(${t("opportunity:process.stepTypes.test.testPrice", {
          price: cost.toFixed(2)
        })})`
      }
      description={t(
        `opportunity:process.stepTypes.test-${source}.${idTest}.description`
      )}
      icon={iconByTestKey(testKey)}
      iconColor={iconColor}
      iconBackgroundColor={iconBackgroundColor}
    />
  );
};

export default withTheme(TestOption);
